<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @selection-change="selectionChange"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-back"
                   plain
                   @click="handleBack">返 回
        </el-button>

        <template v-if="settleMode != 'list'">
          <el-button type="primary"
                    size="small"
                    icon="el-icon-add"
                    plain
                    @click="handlePick">挑 单
          </el-button>
        </template>

      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {getPage, getDetail} from "@/api/epmall/order";
  import {mapGetters} from "vuex";
import { pickorders } from "../../api/epmall/settlesheet";

  export default {
    data() {
      return {
        storeId:0,
        settleId:'',
        settleMode : 'pick',
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          selection:true,
          height:'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          addBtn:false,
          delBtn:false,
          editBtn:false,
          searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          dialogClickModal: false,
          column: [
            {
              label: "订单号",
              prop: "orderId",
              width:150,
              rules: [{
                required: true,
                message: "请输入订单id",
                trigger: "blur"
              }]
            },
            {
              label: "实付金额",
              prop: "payment",
              rules: [{
                required: true,
                message: "请输入实付金额",
                trigger: "blur"
              }]
            },
            {
              label: "支付类型",
              prop: "paymentType",
              type: 'select',
              dicData:[{
                label: "在线支付",
                value: 1
              },
              {
                label: "货到付款",
                value: 2
              }],
              rules: [{
                required: true,
                message: "请输入支付类型 1在线支付 2货到付款",
                trigger: "blur"
              }]
            },
            {
              label: "付款时间",
              prop: "paymentTime",
              addDisplay: false,
              rules: [{
                required: true,
                message: "请输入付款时间",
                trigger: "blur"
              }]
            },
            {
              label: "交易完成时间",
              prop: "endTime",
              addDisplay: false,
              rules: [{
                required: true,
                message: "请输入交易完成时间",
                trigger: "blur"
              }]
            },
            {
              label: "买家昵称",
              prop: "buyerNick",
              rules: [{
                required: true,
                message: "请输入买家昵称",
                trigger: "blur"
              }]
            },
            {
              label: "店铺名称",
              prop: "storeName",
              rules: [{
                required: true,
                message: "请输入店铺id",
                trigger: "blur"
              }]
            }
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.epmallorder_add, false),
          viewBtn: this.vaildData(this.permission.epmallorder_view, false),
          delBtn: this.vaildData(this.permission.epmallorder_delete, false),
          editBtn: this.vaildData(this.permission.epmallorder_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    mounted(){
      this.storeId = this.$router.currentRoute.query.storeId;
      this.settleId = this.$router.currentRoute.query.settleId;
      this.settleMode = this.$router.currentRoute.query.mode;
      this.onLoad(this.page);
      //放在数据加载完后执行
      this.$refs.crud.dicInit('cascader');
    },
    methods: {
      selectionChange(list) {
        this.selectionList = list;
      },
      handlePick(){
        let _this = this;
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        this.$confirm("确定提交到结算单?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            pickorders(_this.settleId,ids.join(",")).then(res=>{
              this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            });
          })        
      },
      handleBack(){
        this.$router.go(-1);
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          loading();
          window.console.log(error);
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          loading();
          console.log(error);
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove(row.id);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove(this.ids);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail(this.form.id).then(res => {
            this.form = res.data.data;
          });
        }
        done();
      },
      searchReset() {
        this.query = {};
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
        done();
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage){
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize){
        this.page.pageSize = pageSize;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
      onLoad(page, params = {}) {
        if(this.storeId == 0)
          return;
        this.loading = true;
        params.storeId = this.storeId;
        if(this.settleMode != 'pick')
          params.settleId = this.settleId;
        getPage(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style>
</style>
